import { useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ShieldCheck, ScrollText } from "lucide-react";

const PLEDGE = `أتعهد أنا منسق/منسقة التطوع بأن جميع البيانات التي أُدخلها في سجل عطاء وأثر تعليم الشرقية — من فرص تطوعية، ومتطوعين، وساعات، وأنشطة، وصور، وإحصاءات — صحيحة ومطابقة للواقع الفعلي في المدرسة.

كما أقرّ بأنني أتحمّل كامل المسؤولية عن دقة البيانات وحداثتها، وأن أُحدّث سجلات المتطوعين والساعات أولاً بأول دون تأخير.

وأتعهد بصون خصوصية بيانات الطلاب والطالبات والموظفين والموظفات وعدم استخدامها إلا لأغراض العمل التطوعي الرسمية، وبالالتزام بأدلة وزارة التعليم للعمل التطوعي وقيمه الست: الانضباط، والأمانة، والعزيمة، والتسامح، والتعاون، والانتماء الوطني.

وإذ أوقّع على هذا التعهد، فإنني أعتز بثقة مدرستي وثقة قسم المسؤولية المجتمعية والعمل التطوعي، وأعد بأن تكون بصمتي في الخير باقية.`;

export default function PledgeModal({ onAccept }) {
  const { user } = useAuth();
  const [agreed, setAgreed] = useState(false);
  const [busy, setBusy] = useState(false);

  const accept = async () => {
    if (!agreed) return;
    setBusy(true);
    try {
      await api.post("/auth/accept-pledge");
      toast.success("تم تسجيل تعهدك — أهلاً بك في سجل عطاء وأثر");
      onAccept();
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="pledge-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-surface rounded-3xl shadow-2xl border border-brd w-full max-w-lg p-6 text-center animate-fade-up">
        <div className="w-14 h-14 mx-auto rounded-2xl bg-turq-900 flex items-center justify-center mb-4 shadow-lg shadow-turq-900/25">
          <ShieldCheck className="w-7 h-7 text-white" />
        </div>
        <h2 className="font-head font-black text-xl text-turq-900 dark:text-turq-300 mb-1">تعهّد والتزام منسق/منسقة التطوع</h2>
        <p className="text-xs text-mutext mb-4">مرحباً {user?.name} — يرجى قراءة التعهد والموافقة عليه قبل الدخول</p>
        <div data-testid="pledge-text" className="bg-bg border border-brd rounded-2xl p-4 max-h-56 overflow-y-auto text-right mb-4">
          <div className="flex items-start gap-2">
            <ScrollText className="w-4 h-4 text-turq-600 mt-1 shrink-0" />
            <p className="text-[13px] leading-relaxed whitespace-pre-line">{PLEDGE}</p>
          </div>
        </div>
        <label className="flex items-center gap-2.5 text-right mb-5 cursor-pointer select-none">
          <input data-testid="pledge-checkbox" type="checkbox" checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)} className="w-5 h-5 rounded accent-[#12939E]" />
          <span className="text-[12.5px] font-bold">أقرّ بأنني قرأت التعهد أعلاه وأوافق عليه وألتزم بمضمونه بصدق ومسؤولية.</span>
        </label>
        <button data-testid="pledge-accept-btn" onClick={accept} disabled={!agreed || busy}
          className="w-full rounded-xl bg-coral-600 hover:bg-coral-900 disabled:opacity-40 text-white font-bold py-3.5 text-sm transition-colors flex items-center justify-center gap-2">
          <ShieldCheck className="w-4 h-4" />
          {busy ? "جارٍ التسجيل …" : "أوافق وأدخل المنصة"}
        </button>
      </div>
    </div>
  );
}
